import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CUIText, DialogContentType, IconNames, NoCrNoHDialog, useHPlusContents } from '@dotcom/crown-ui';
import HallmarkPlus from '../../assets/hallmark-plus.svg';
import { useInitializationDataContext } from '../../context/data-context';
import { useLoyaltyContents } from './hooks';
import { NoCrNoHDialogProps } from './no-cr-no-h-dialog-types';
import styles from './no-cr-no-h-dialog.module.scss';

export const NoCrNoH = ({ isOpen, setIsOpen, isLoyaltyCtaVisible }: NoCrNoHDialogProps) => {
  const { t } = useTranslation();
  const { initializedDataState } = useInitializationDataContext();
  const { membershipStatus } = initializedDataState;

  const { onCtaClick } = useHPlusContents({
    membershipStatus: membershipStatus?.plusMembership,
    onCtaClick: () => window.location.replace('/hallmarkplus-account/'),
  });

  const hPlusContainerContent = {
    image: HallmarkPlus,
    body: <CUIText as="span">{t('noCrNoHDialog.secondContainerText')}</CUIText>,
    btnAction: (
      <Button variant="secondary" onClick={onCtaClick} testId="learn-more-dialog-button">
        {t('noCrNoHDialog.secondContainerButtonText')}
      </Button>
    ),
  };

  const { loyaltyContainerContents } = useLoyaltyContents();

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  return (
    <>
      <NoCrNoHDialog
        isOpen={isOpen}
        onClose={handleCloseDialog}
        id="no-cr-no-h-dialog"
        accentIcon={IconNames.PersonPerson}
        hasGrayBackground={true}
        closeButtonId="no-cr-no-h-dialog-close-button"
        hideOverlay={false}
        type={DialogContentType.FeatureModal}
        disableDialogScroll={true}
        testId="no-cr-no-h-dialog"
        firstContainer={isLoyaltyCtaVisible ? loyaltyContainerContents : null}
        secondContainer={hPlusContainerContent}
        addDialogClass={styles['dialog-no-cr-no-h']}
      />
    </>
  );
};
